
export const queryById = (id: string): string => {
  return `*[_id == "${id}"]`;
};